<template>
  <component :is="type" :size="size" :colors="colors"> </component>
</template>
<script>
  import account from '../components/customIcons/account';
  import alarmOutput from '../components/customIcons/alarmOutput';
  import maintenanceHistory from '../components/customIcons/maintenanceHistory';
  import powerConsumption from '../components/customIcons/powerConsumption';
  import operationDataOutput from '../components/customIcons/operationDataOutput';
  import machineInfo from '../components/customIcons/machineInfo';
  import trendGraph from '../components/customIcons/trendGraph';
  import download from '../components/customIcons/download';
  export default {
    name: 'CustomIcon',
    components: {
      account,
      alarmOutput,
      maintenanceHistory,
      powerConsumption,
      operationDataOutput,
      machineInfo,
      trendGraph,
      download,
    },
    props: {
      size: {
        type: Number,
        default: 20,
      },
      type: {
        type: String,
        required: true,
      },
      colors: {
        type: Array,
      },
    },
    data: () => ({}),
    mounted() {},
  };
</script>
